<template>
    <div class="column_center_center customize_popup">
        <div class="column_center_start customize_container">
            <div class="column_center_start w-full px-[30px] flex-grow overflow-y-auto pb-5">
                <text class="title" style="color: #FD5001; font-size: 24px;">{{ product.name }}</text>
                <div class="column_center_center" style="width: 100%;" v-for="(spec, specIndex) in productSpecSettings"
                    :key="specIndex">
                    <div class="column_start_start w-full flex-wrap" style="padding: 15px 0">
                        <div class="row_center_start w-full">
                            <text class="title">{{ specDisplayName(spec) }}</text>
                            <text class="subTitle" v-if="spec.mustHave">必選</text>
                        </div>
                        <text class="subTitle" style="margin-left: 0;" v-if="!spec.isSingleSelection">複選[最少{{
                    spec.multiSelectionMin }}, 最多{{ spec.multiSelectionMax }}]{{
                    spec.allowSelectManyTimes ? '(可重複選)' : '' }}</text>
                    </div>
                    <div class="option_container w-full" v-if="!spec.allowSelectManyTimes">
                        <!-- 單選 複選欄位 -->
                        <customizeSingleSubOption class="row_center_center option"
                            :class="{ active: isSelected(specIndex, subSpecIndex) }"
                            v-for="(subSpec, subSpecIndex) in spec.specOptions" :key="subSpecIndex" :subOption="subSpec"
                            @click="spec.isSingleSelection ? selectedSingleItem(specIndex, subSpecIndex) : multipleSelectItem(specIndex, subSpecIndex)" />
                    </div>
                    <div class="column_center_start w-full" v-if="spec.allowSelectManyTimes">
                        <!-- 可重複選欄位 -->
                        <customizeMultiSubOption class="column_center_start option" style="width: 100%;"
                            :class="{ active: isSelected(specIndex, subSpecIndex) }"
                            v-for="(subSpec, subSpecIndex) in spec.specOptions" :key="subSpecIndex" :subOption="subSpec"
                            @addQuantity="addOptionQuantity(specIndex, subSpecIndex)"
                            @subtractQuantity="subtractOptionQuantity(specIndex, subSpecIndex)"
                            :quantity="checkOptionQuantity(specIndex, subSpecIndex)" />
                    </div>
                </div>
            </div>
            <div class="row_center_between" style="width: 100%;">
                <button @click="close" class="cancel_button">取消</button>
                <button @click="confirm" class="confirm_button">確認</button>
            </div>
        </div>
    </div>
</template>
<script>
import commonUtilities from "@/utils/common.utils";
import customizeSingleSubOption from "@/components/store/customizeSingleSubOption.vue";
import customizeMultiSubOption from "@/components/store/customizeMultiSubOption.vue";
import { mapGetters, mapState } from "vuex";
export default {
    components: {
        customizeSingleSubOption,
        customizeMultiSubOption
    },
    data() {
        return {
            productSpecSettings: {}
        }
    },
    computed: {
        ...mapState("cart", {
            selectedComboProduct: 'selectedComboProduct',
            customizedOptions: 'customizedOptions',
        }),
        ...mapGetters('spreadsheet', {
            specifications: 'specifications',
        }),
        product() {
            return this.selectedComboProduct.product
        },
        groupIndex() {
            return this.selectedComboProduct.groupIndex
        }
    },
    mounted() {
        console.log('customized product', this.product);
        this.productSpecSettingsInit()
    },
    methods: {
        toBoolean(value) {
            return (/true/).test(value)
        },
        productSpecSettingsInit() {
            this.productSpecSettings = this.product.productSpecSettings.map(subSpec => {
                if (subSpec.specOptions !== undefined) {
                    return subSpec
                }
                const subSpecID = String(subSpec.subSpecID || '').trim()
                const specIndex = this.specifications.findIndex(spec => String(spec.id || '').trim() === subSpecID)
                let spec = {}
                if (specIndex !== -1) {
                    spec = this.specifications[specIndex]
                    // spec.specOptions 有多少選項 就在 subSpecOptionSelectCount 設定多少個 0
                    subSpec['subSpecOptionSelectCount'] = spec?.specOptions.map(() => 0) || []
                }
                return { ...subSpec, ...spec }
            })
            console.log(this.productSpecSettings)
        },
        checkOptionQuantity(specIndex, subSpecIndex) {
            return this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]
        },
        addOptionQuantity(specIndex, subSpecIndex) {
            // 複選 ＆ 可重複選則加點數量
            // 檢查是否超過最大選擇數
            const currentSpecSelectCount = this.productSpecSettings[specIndex].subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)
            const currentSpecSelectionMax = this.productSpecSettings[specIndex].multiSelectionMax
            if (currentSpecSelectCount >= currentSpecSelectionMax) {
                commonUtilities.createToast("warning", `最多選擇${currentSpecSelectionMax}個`, "")
                return
            }
            this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]++
        },
        subtractOptionQuantity(specIndex, subSpecIndex) {
            const currentSpecSelectCount = this.productSpecSettings[specIndex].subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)
            // 如果加點數量為 0 或是該選項沒有被選中，則不做任何事
            if (currentSpecSelectCount === 0 || this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex] === 0) {
                return
            }
            // 如果加點數量為1，則移除選項
            if (currentSpecSelectCount == 1) {
                this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]--
                return
            }
            // 如果加點數量大於1，則數量減一
            if (currentSpecSelectCount > 1) {
                this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]--
            }
        },
        selectedSingleItem(specIndex, subSpecIndex) {
            // 單選
            const hasSelected = this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex] > 0

            if (!hasSelected) {
                // 將選到的 subSpecOptionSelectCount[subSpecIndex] 設為 1，其餘設為0
                this.productSpecSettings[specIndex].subSpecOptionSelectCount = this.productSpecSettings[specIndex].subSpecOptionSelectCount.map((el, i) => {
                    return i === subSpecIndex ? 1 : 0
                })
            } else {
                this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex] = 0
            }
        },
        multipleSelectItem(specIndex, subSpecIndex) {
            // 複選
            // 檢查選項是否已經被選中
            const hasSelected = this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex] > 0

            if (!hasSelected) {
                // 檢查是否超過最大選擇數
                if (this.productSpecSettings[specIndex].subSpecOptionSelectCount >= this.productSpecSettings[specIndex].multiSelectionMax) {
                    commonUtilities.createToast("warning", `最多選擇${this.productSpecSettings[specIndex].multiSelectionMax}個`, "")
                    return
                }
                // 如果沒有被選中，則將選項加入選中的選項中
                this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]++
            } else {
                // 如果已經被選中，則從選中的選項中移除
                this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex]--
            }
        },
        isSelected(specIndex, subSpecIndex) {
            return this.productSpecSettings[specIndex].subSpecOptionSelectCount[subSpecIndex] > 0
        },
        close() {
            this.$store.commit("cart/setSelectedComboProduct", null);
            this.$emit("close");
        },
        customizeItemValidator() {
            for (const option of this.productSpecSettings) {
                const displayName = this.specDisplayName(option)
                const totalQuantity = option.subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)
                // 如果是必選 檢查 selectedItemsArray 是否有值
                if (option.mustHave && totalQuantity === 0) {
                    throw `${displayName}尚未選擇`
                }
                // 如果是單選並且是必選 檢查 selectedItemsArray length 是否為1
                if (option.mustHave && option.isSingleSelection && totalQuantity !== 1) {
                    throw `${displayName}尚未選擇`
                }
                // 如果是複選 or 可重複選 加總 selectedItemsArray 中各項的 quantity 是否符合 minSelect, maxSelect
                if (!option.isSingleSelection) {
                    if (totalQuantity < option.multiSelectionMin) {
                        throw `${displayName}尚未選擇`
                    }
                    if (totalQuantity > option.multiSelectionMax) {
                        throw `${displayName}選擇數量超過最大值`
                    }
                }
            }
        },
        specDisplayName(spec) {
            return spec.frontEndDisplayName || spec.name
        },
        confirm() {
            try {
                this.customizeItemValidator()
            } catch (error) {
                commonUtilities.createToast("warning", error, "")
                return
            }
            const product = { ...this.product }
            product.productSpecSettings = this.productSpecSettings
            this.$store.commit("cart/setSelectedComboProduct", { product, groupIndex: this.groupIndex });
            this.$emit("close");
        }
    }
}
</script>
<style lang="scss" scoped>
.customize_popup {
    background: #00000098;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
     z-index: 9999;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.customize_popup::-webkit-scrollbar {
    display: none;
}

.customize_container {
    max-height: 90%;
    background-color: #fff;
    padding-top: 30px;
    width: 90%;
    border-radius: 6px;
    z-index: 10000; 
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.customize_container::-webkit-scrollbar {
    display: none;
}

.option_container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}

.option {
    width: 48%;
    padding: 9px 4%;
    border: #AAAAAA 1px solid;
    background-color: #fff;
    font-size: 18px;
    font-weight: 400;
    font-family: PingFang SC;
    margin-bottom: 10px;
    border-radius: 6px;
    color: #000;

    text {
        flex-wrap: wrap;
    }
}

.option.active {
    border: #FD4F02 2px solid;
    background-color: #fff;
}

button {
    width: 49.6%;
    height: 56px;
    border: none;
    font-size: 20px;
    font-weight: 500;
    font-family: PingFang SC;
    color: #000;
}

.cancel_button {
    border-radius: 0 0 0 8px;
    background-color: #EEEEEE;
}

.confirm_button {
    border-radius: 0 0 8px 0;
    background-color: #FBCB02;
}

.subTitle {
  font-size: 14px;
  font-weight: 400;
  font-family: PingFang SC;
  color: #d60c0a;
  margin-left: 10px;
}
</style>
